import debounce from 'lodash/debounce'
import * as React from 'react'
import { FunctionComponent } from 'react'
import styles from './GardientButtonStyles.module.scss'

export interface GradientButtonProps {
  /**
   * If `true`, the button will show a spinner.
   */
  isLoading?: boolean
  /**
   * If `true`, the button will be disabled.
   */
  isDisable?: boolean
  /**
   * If `true`, the button will take up the full width of its container.
   */
  isFullWidth?: boolean
  /**
   * The html button type to use.
   */
  type?: 'button' | 'reset' | 'submit'
  /**
   * Is this the principal call to action on the page?
   */
  variant?: 'orange' | 'gray'
  /**
   * How large should the button be?
   */
  size?: 'sm' | 'md' | 'lg' | 'custom'
  /**
   * Button contents
   */
  children: React.ReactNode
  /**
   * Optional click handler
   */
  onClick?: () => void
  /**
   * add custom css
   */
  customCss?: string
  /**
   * adds debouncing delay for button click calls
   */
  delay?: number
}

export const GradientButton: FunctionComponent<GradientButtonProps> = ({
  isDisable,
  isFullWidth,
  onClick,
  children,
  customCss,
  delay,
  size = 'md',
  variant = 'orange',
  ...props
}) => {
  const onClickHandler = debounce(() => {
    if (!isDisable && onClick) {
      onClick()
    }
  }, delay)

  return (
    <button
      type="button"
      className={[
        styles['button'],
        isDisable ? styles['disable-yes'] : styles['disable-no'],
        isFullWidth && 'w-full',
        customCss ? customCss : '',
        styles['variant-' + variant],
        styles['size-' + size],
      ].join(' ')}
      onClick={onClickHandler}
      {...props}
    >
      {children}
    </button>
  )
}
